// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"ed9bb6dc","481":"ed9bb6dc","870":"ed9bb6dc","956":"ed9bb6dc"}[chunkId] + ".chunk.css";
};